//
// 模态框
// ============================================================
import Ns from "./utility";

let modal = (options) => {
    if(modalError(options) == "err") return;

    let str2 = "";
    if (options.buttonHandle.length) {
        Ns.each(options.buttonHandle, item => {
            if(typeof item.name == "string" && typeof item.text == "string") {
                str2+= '<div data-modal-button="' + item.name + '" class="modal-button-item">'+ item.text +'</div>';
            }
        }, true)
    }else {
        if(typeof options.buttonHandle.name == "string" && typeof options.buttonHandle.text == "string") {
            str2= '<div data-modal-button="' + options.buttonHandle.name + '" class="modal-button-item">'+ options.buttonHandle.text +'</div>';
        }
    }

    if (ns(".modal-wrapper").get().length != 0){
        ns(".modal-wrapper").attr("data-animtion", options.animation).addClass("active");
        options.title ? ns(".modal-wrapper .modal-title").text(options.title) : "";
        options.content ? ns(".modal-wrapper .modal-content").html(options.content) : "";
        options.buttonHandle ? ns(".modal-wrapper .modal-button").html(str2) : "";
    }else {
        let str = `
                <div class="modal-wrapper active" data-animtion="` + options.animation + `">
                    <div class="modal-shade"></div>
                    <div class="modal-box" data-animtion-move>
                        <div class="modal-title">` + options.title + `</div>
                        <div class="modal-content">` + options.content + `</div>
                        <div class="modal-button">` + str2 + `</div>
                    </div>
                </div>`;

        ns("body").addClass("overflow-hidden").append(str);
    }


    let height = ns(".modal-wrapper>.modal-box").getStyle("height");
    let width = ns(".modal-wrapper>.modal-box").getStyle("width");
    ns(".modal-wrapper>.modal-box").css({
        marginTop: -(height/2) + "px",
        marginLeft: -(width/2) + "px"
    });

    return modalHandle(options.buttonHandle);
};

let modalError = (options) => Ns.err({
    arg: [{
        name: ["title", "content", "el", "animation"],
        value: [options.title, options.content, options.el, options.animation],
        typeof: "string",
        isNull: true,
    }, {
        name: "buttonHandle",
        value: options.buttonHandle,
        typeof: "string object",
        isNull: true,
    }],
    method: "Modal()",
});

// 隐藏
let modalHide = el => {
    ns(el).parents(".modal-wrapper").addClass("unactive");
    setTimeout( () => ns(el).parents(".modal-wrapper").removeClass("active unactive"), 500);
    ns("body").removeClass("overflow-hidden");
};

// 事件
let modalHandle = buttonHandle => new Ns({
    el: ".modal-wrapper",
    eventHandle: [{
        type: "click",
        entrust: ".modal-shade",
        callback:  function (ev) {
            return modalHide(this);
        }
    }, {
        type: "click",
        entrust: ".modal-button-item",
        callback:  function (ev) {
            let buttonAttr = ns(this).attr("data-modal-button");
            let result= true, self= this;
            if (buttonHandle.length) {
                Ns.each(buttonHandle, item => {
                    if (item.callback && typeof item.callback === "function" && item.name == buttonAttr) {
                        result = item.callback.call(self, ev);
                    }
                }, true)

            }else if (buttonHandle.callback && typeof buttonHandle.callback === "function"){
                result = buttonHandle.callback.call(self, ev);
            }

            if( result != false ) {
                modalHide(this)
            }else {
                return true;
            }
        }
    }]
});

const Modal = ({execute, el, title= "提示", content= "内容君请假了ヾ(｡｀Д´｡)", animation= "", buttonHandle} = {}) => new Ns({
    el: el,
    eventHandle: {
        type: "click",
        callback:  function (ev) {
            return modal({title, content, animation, buttonHandle});
        }
    },
    callback() {
        if(execute == "auto") modal({title, content, animation, buttonHandle});
    }
});

module.exports = Modal;


// WEBPACK FOOTER //
// src/js/modal.js